import { useState } from "react"
import { JobbinInputWhite } from "../../components/jobbinInputWhite"
import { JobbinPrimaryButton } from "../../components/primaryButton"
import { LoadingComponent } from "../../components/loading"
import { useLoading } from "../../context/loading"
import { useNavigate, useLocation } from "react-router-dom"
import { useVerifyEmail, useResendVerificationEmail } from "../../hooks/auth-hooks"

export const VerifyEmailPage = () => {
    const { loading, setLoading } = useLoading()
    const { verifyEmail } = useVerifyEmail()
    const { resendEmail } = useResendVerificationEmail()
    const navigate = useNavigate()
    const location = useLocation()

    // Email passed from signup page via navigate state
    const email: string = location.state?.email ?? ""

    const [code, setCode] = useState("")
    const [error, setError] = useState<string | null>(null)
    const [successMessage, setSuccessMessage] = useState<string | null>(null)

    const doVerify = async () => {
        setError(null)

        // 6-digit validation
        if (!/^\d{6}$/.test(code)) {
            setError("Codul de verificare trebuie să conțină exact 6 cifre.")
            return
        }

        setLoading(true)

        try {
            const data = await verifyEmail(code)
            localStorage.setItem("jwtToken", data.token)
            navigate("/home")
        } catch (e: any) {
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    const doResend = async () => {
        setError(null)
        setSuccessMessage(null)

        if (!email) {
            setError("Adresa de email lipsește. Încearcă să te înregistrezi din nou.")
            return
        }

        setLoading(true)

        try {
            await resendEmail(email)
            setSuccessMessage("Codul a fost retrimis. Verifică emailul.")
        } catch (e: any) {
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div id="verify-email-page" className="bg-figmaLightBg min-h-screen">
            {loading && <LoadingComponent />}

            <div className="grid min-h-screen grid-cols-1 lg:grid-cols-12">
                <div className="col-span-1 lg:col-span-5 flex items-center justify-center px-4 py-8 sm:px-6 md:px-8">
                    <div className="w-full max-w-md">
                        <img
                            className="mt-2 mb-8 w-[140px] sm:w-[170px]"
                            src="/images/jobbin-logo-with-icon.png"
                            alt="Jobbin"
                        />

                        <div className="text-start">
                            <h3 className="text-figmaBlack text-[28px] sm:text-[32px] font-bold">
                                Verificare email
                            </h3>
                            <p className="mt-2 text-figmaDarkGray font-bold text-sm sm:text-base break-words">
                                Am trimis un cod de verificare la {email ? <strong>{email}</strong> : "adresa dvs. de email"}.
                                Introduceți-l mai jos pentru a activa contul.
                            </p>
                        </div>

                        {error && (
                            <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded text-sm sm:text-base">
                                {error}
                            </div>
                        )}

                        {successMessage && (
                            <div className="mt-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded text-sm sm:text-base">
                                {successMessage}
                            </div>
                        )}

                        <div className="mt-6">
                            <JobbinInputWhite
                                type="text"
                                label="Cod de verificare"
                                name="code"
                                placeholder="Introduceți codul de 6 cifre"
                                onChange={(e) => setCode((e.target as HTMLInputElement).value)}
                                maxLength={6}
                            />
                        </div>

                        <div className="mt-8">
                            <JobbinPrimaryButton onClickAction={doVerify} text="Verifică" />
                        </div>

                        <p
                            className="mt-4 text-figmaContrast font-bold cursor-pointer text-sm sm:text-base"
                            onClick={doResend}
                        >
                            Retrimite codul
                        </p>

                        <p
                            className="mt-3 text-figmaBlack font-bold cursor-pointer text-sm sm:text-base"
                            onClick={() => navigate("/")}
                        >
                            Înapoi la login
                        </p>
                    </div>
                </div>

                <div className="hidden lg:flex lg:col-span-7 bg-figmaWhite items-center justify-center p-8">
                    <img
                        className="max-w-full h-auto"
                        src="/images/jobbin-logo-with-icon.png"
                        alt="Jobbin"
                    />
                </div>
            </div>
        </div>
    )
}